import script from "./FeedbackManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedbackManager.vue?vue&type=script&setup=true&lang=ts"

import "./FeedbackManager.vue?vue&type=style&index=0&id=2726ec22&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2726ec22"]])

export default __exports__